import React from "react";
import { gql, useQuery } from "@apollo/client";
import {
  GlobalDispatchContext,
  GlobalStateContext,
} from "../context/global-context-provider";

/* Looks up the signed-in WordPress user. That is a cross-origin GraphQL request
 * (preflight + POST) followed by a context update that re-renders the page, so it
 * only runs where the user is actually needed: the /app/* pages and components that
 * dispatch REQUIRE_USER (see Layout and UpdateUser). */
export default function CheckUser() {
  const { needsUser } = React.useContext(GlobalStateContext);
  const dispatch = React.useContext(GlobalDispatchContext);
  const { data, loading } = useQuery(VIEWER, { skip: !needsUser });

  React.useEffect(() => {
    if (needsUser && !loading) {
      dispatch({ type: "SET_USER", value: data?.viewer || null });
    }
  }, [data, loading, needsUser]);
  return null;
}

export const VIEWER = gql`
  query Viewer {
    viewer {
      nicename
      id
      firstName
      lastName
      email
    }
  }
`;
